<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.0937 14.7395V19.1666C21.0937 20.3067 20.2741 21.2874 19.1439 21.4375C16.9703 21.726 14.7525 21.875 12.5 21.875C10.2475 21.875 8.02973 21.726 5.85609 21.4375C4.72593 21.2874 3.90625 20.3067 3.90625 19.1666V14.7395M21.0937 14.7395C21.5853 14.3205 21.875 13.6863 21.875 13.0093V9.06842C21.875 7.94245 21.0751 6.9696 19.9615 6.80298C18.7892 6.62757 17.6037 6.49287 16.4062 6.40034M21.0937 14.7395C20.8921 14.9114 20.6564 15.0471 20.3928 15.1348C17.9118 15.9596 15.2581 16.4062 12.5 16.4062C9.74196 16.4062 7.08822 15.9596 4.60717 15.1348C4.34359 15.0471 4.10793 14.9114 3.90625 14.7395M3.90625 14.7395C3.41466 14.3204 3.125 13.6863 3.125 13.0092V9.06843C3.125 7.94245 3.9249 6.9696 5.03848 6.80298C6.21076 6.62758 7.39634 6.49287 8.59375 6.40034M16.4062 6.40034V5.46875C16.4062 4.17433 15.3569 3.125 14.0625 3.125H10.9375C9.64308 3.125 8.59375 4.17433 8.59375 5.46875V6.40034M16.4062 6.40034C15.1173 6.30073 13.8146 6.25 12.5 6.25C11.1855 6.25 9.88275 6.30073 8.59375 6.40034M12.5 13.2812H12.5078V13.2891H12.5V13.2812Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBriefCase',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
